import { render, staticRenderFns } from "./Ydbjl.vue?vue&type=template&id=3d84a2a6&scoped=true"
import script from "./Ydbjl.vue?vue&type=script&lang=js"
export * from "./Ydbjl.vue?vue&type=script&lang=js"
import style0 from "./Ydbjl.vue?vue&type=style&index=0&id=3d84a2a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d84a2a6",
  null
  
)

export default component.exports